//联系我们
import React from "react";
import {Col, Divider, Row} from "antd";
import "../CSS/style.css"
import "../CSS/ContactUs.css"
import aboutUs from "../Home/img/aboutUs.png"
import phone from "../Home/img/phone.png"
import phoneNumber from "../Home/img/phoneNumber.png"
import emailUs from "../Home/img/emailUs.png"
import location from "../Home/img/location.png"
import Developers from "../Home/img/aboutUs-Developers.png"
import LearningTeam from "../Home/img/aboutUs-LearningTeam.png"
import Researcher from "../Home/img/aboutUs-Researcher.png"
import { scrollToTop } from './../Utils/CommonFunc';
import { copyrightIco, copyrightLogo, highTeachIco1, highTeachIco2, highTeachLogo,
    patentLogo, patentIcon } from './../Utils/ExportImage';
import { titleSize, subtitleSize, contentSize, contentColor, subSubTitleSize } from './../Utils/CommonVar';

export default class ContactUs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data_info : [[106.382507,29.605125,"重庆米弘科技有限公司层"],
                [106.382507,29.505125,"地址：北京市东城区东华门大街"],
                [106.382507,29.555125,"地址：北京市东城区正义路甲5号"]
            ],
            companyTeamText :[],
        }
    }
    componentWillMount() {
        scrollToTop(0);
        setTimeout(()=>{
            this.renderMap()
        },100);
        this.getCompanyTeamText()
    }
    renderMap = () =>{
        const { BMap, BMAP_STATUS_SUCCESS } = window
        const content = (
            <Row style={{width:30, height:30}}>
                <p>米弘科技</p>
                <Row>soho楼</Row>
            </Row>
        )
        let map = new BMap.Map("orderDetailMap");
        map.centerAndZoom(new BMap.Point(106.382507,29.605125), 19);
        map.enableScrollWheelZoom();
        let p2 = new BMap.Point(106.382507,29.605125);
        let marker = new BMap.Marker(p2); //将点转化成标注点
        map.addOverlay(marker);  //将标注点添加到地图上
        let label = new BMap.Label("米弘科技",{offset: new BMap.Size(20,-10)});
        label.setStyle({"borderColor":"gray", "fontSize":"16px"});//设置框的样式
        marker.setLabel(label);
    }
    getCompanyTeamText = () => {
        const companyTeamText = [
            {
                title: '学习型团队',
                details: '我们拥有一支同时具备科学研究能力和工程实现能力的学习型团队。',
                picture: LearningTeam
            },{
                title: '研究人员',
                details: '主要由重庆大学智能服务与软件工程中心教授和博士组成，长期从事大数据挖掘、机器学习、计算机视觉、软件工程等人工智能与产业相结合的应用研究。',
                picture: Researcher
            },{
                title: '开发人员',
                details: '核心开发人员毕业于重庆大学大数据与软件学院，曾供职于华为、深信服、金蝶、中航信等国内知名企业，软件从业经验10年。',
                picture: Developers
            }
        ]
        this.setState({companyTeamText})
    }
    render() {
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        const { companyTeamText } = this.state
        const companyTeamHtml = companyTeamText.map((item, index) => (
            <Row className="honor-container" key={index} >
                <Row style={{textAlign: "center"}}><img src={item.picture} alt="picture" width={80}/></Row>
                <p  className="honorTitle"> {item.title}</p>
                <Divider/>
                <p className="center-team" style={{ fontSize: contentSize }}>
                    {item.details}
                </p>
            </Row>
        ))

        return(
            <div style={{marginTop:72}}>
                <div style={{position:'relative',zIndex:2}}><img src={aboutUs} alt='picture' width={width} height={height} /></div>
                <div style={{background:"#F2F6F9"}}>
                    <div className="all" style={{width:1200}}>
                        <Row style={{padding: '64px 60px'}}>
                            <Row>
                                <div style={{paddingBottom:48}}>
                                    <Row type="flex" justify="center">
                                        <Row>
                                            <Row style={{fontSize: titleSize, textAlign:"center"}}>公司介绍</Row>
                                            <Row style={{fontSize: subtitleSize, color:'#858585',textAlign:"center"}}>Company Profile</Row>
                                        </Row>
                                    </Row>
                                </div>
                            </Row>
                            <Row type="flex" justify="center" align="middle">
                                <div style={{width:1200}}>
                                    <Row type="flex" align="middle" style={{lineHeight:2,textIndent:40, fontSize: contentSize, color: contentColor }}>
                                        <p>重庆米弘科技有限公司成立于2012年，国家高新技术企业、重庆市科技型企业。
                                            主要从事智能应用软件研发，推进智能技术与行业应用相结合， 针对劳动密集型智力稀疏型应用场景， 提供柔性智能化改造服务，
                                            提升企业核心竞争力，推动行业高质量发展，为社会发展注入新动能。
                                        </p>
                                        <p>我们致力于成为全领域应用型智能化解决方案服务商。
                                        </p>
                                    </Row>
                                </div>
                            </Row>
                        </Row>
                    </div>
                </div>
                <div>
                    <div className="all" style={{width:1200}}>
                        <Row style={{padding:'64px 60px'}}>
                            <div style={{paddingBottom:48}}>
                                <Row type="flex" justify="center">
                                    <Row>
                                        <Row style={{fontSize:titleSize,textAlign:"center"}}>核心团队</Row>
                                        <Row style={{fontSize:subtitleSize, color:'#858585',textAlign:"center"}}>Core Team</Row>
                                    </Row>
                                </Row>
                            </div>
                            <Row type="flex" justify="space-between" >
                                {companyTeamHtml}
                            </Row>
                        </Row>
                    </div>
                </div>
                <div style={{ background:"#F2F6F9"}}>
                    <div className="all" style={{width:1200}}>
                        <Row style={{padding:'64px 60px'}}>
                            <div style={{paddingBottom:48}}>
                                <Row type="flex" justify="center">
                                    <Row>
                                        <Row style={{fontSize:titleSize,textAlign:"center"}}>公司荣誉</Row>
                                        <Row style={{fontSize:subtitleSize, color:'#858585',textAlign:"center"}}>Company Honor</Row>
                                    </Row>
                                </Row>
                            </div>
                            <Row type="flex" justify="space-between" style={{margin:"20px 0"}} >
                                <Row style={{width:250, textAlign: 'center', }}>
                                    {/*<img src={honer1} alt='picture' width="100%"/>*/}
                                    <img src={highTeachLogo} alt='picture' height={80} />
                                    <p  className="honorTitle" style={{ margin: '10px auto', fontWeight: "bold"}}> 国家高新技术企业</p>
                                    <img src={highTeachIco1} alt='picture' width="100%" height={165}/>
                                    <img src={highTeachIco2} alt='picture' width="100%" height={165} style={{ marginTop: 10 }}/>
                                </Row>
                                <Row style={{width:250, textAlign: 'center', }}>
                                    {/*<img src={honer2} alt='picture' width="100%"/>*/}
                                    <img src={patentLogo} alt='picture' height={80} />
                                    <p  className="honorTitle" style={{ margin: '10px auto', fontWeight: "bold"}}> 发明专利三项</p>
                                    <img src={patentIcon} alt='picture' width="100%" height={340}/>
                                </Row>
                                <Row style={{width:250, textAlign: 'center',  }}>
                                    <img src={copyrightLogo} alt='picture' height={80} />
                                    <p  className="honorTitle" style={{ margin: '10px auto', fontWeight: "bold"}}> 软件著作权二十一项</p>
                                    <img src={copyrightIco} alt='picture' width="100%" height={340}/>
                                </Row>
                            </Row>
                        </Row>
                    </div>
                </div>
                <div>
                    <div  className="all" style={{ width:1200 }}>
                        <Row style={{padding:'64px 60px'}}>
                            <div style={{paddingBottom:48}}>
                                <Row type="flex" justify="center">
                                    <Row>
                                        <Row style={{fontSize:titleSize,textAlign:"center"}}>联系我们</Row>
                                        <Row style={{fontSize:subtitleSize, color:'#858585',textAlign:"center"}}>Contact Us</Row>
                                    </Row>
                                </Row>
                            </div>
                            <Row type="flex" justify="center" style={{padding:"20px 0"}} >
                                <Row type="flex" justify="center" style={{border:'1px solid #858585'}}>
                                    <div id="orderDetailMap" style={{ width: 750, height: 500 }}>公司地址</div>
                                </Row>
                                <Row type="flex" align="middle">
                                    <Row style={{ marginLeft: 80 }}>
                                        <Row style={{ height: 80 }} type="flex" align="middle">
                                            <img src={phone} alt="phone"/>
                                            <Row className="company-detail" style={{fontSize: contentSize }}>023-65392396</Row>
                                        </Row>
                                        <Row style={{ height: 80 }} type="flex" align="middle">
                                            <img src={phoneNumber} alt="phoneNumber"/>
                                            <Row className="company-detail" style={{fontSize: contentSize }}>13368396612(李老师)</Row>
                                        </Row>
                                        <Row style={{ height: 80 }} type="flex" align="middle">
                                            <img src={emailUs} alt="emailUs"/>
                                            <Row className="company-detail" style={{fontSize: contentSize }}>meehoo@meehoo.com</Row>
                                        </Row>
                                        <Row style={{ height: 80 }} type="flex" align="middle">
                                            <img src={location} alt="location"/>
                                            <Row className="company-detail" style={{fontSize: contentSize }}>重庆市高新区西永微电子产业园区SOHO楼1703</Row>
                                        </Row>
                                    </Row>
                                </Row>
                            </Row>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }
}